module.exports = __webpack_public_path__ + "img/darwinkopf.8c27cfbe.jpg";